import { NavLink, useLocation } from 'react-router-dom'
import { LucideIcon } from 'lucide-react'

export interface TabItem {
  label: string
  path: string
  icon?: LucideIcon
  badge?: number | string
  end?: boolean // Si debe matchear exactamente la ruta
}

interface DetailTabsProps {
  tabs: TabItem[]
  basePath: string
}

export function DetailTabs({ tabs, basePath }: DetailTabsProps) {
  const location = useLocation()

  return (
    <div className="border-b border-gray-200 dark:border-slate-700">
      <nav className="-mb-px flex gap-1 overflow-x-auto scrollbar-hide" aria-label="Tabs">
        {tabs.map((tab) => {
          const fullPath = tab.path ? `${basePath}/${tab.path}` : basePath
          const isActive = tab.end
            ? location.pathname === fullPath
            : location.pathname.startsWith(fullPath) && (tab.path === '' || location.pathname === fullPath || location.pathname.startsWith(`${fullPath}/`))

          // Para la pestaña principal (path vacío), solo activar si es exacta
          const shouldBeActive = tab.path === ''
            ? location.pathname === basePath
            : isActive

          return (
            <NavLink
              key={tab.path}
              to={fullPath}
              className={`
                relative flex items-center gap-2 px-4 py-3 text-sm font-medium whitespace-nowrap
                transition-all duration-200 rounded-t-lg
                ${shouldBeActive
                  ? 'text-primary-600 dark:text-primary-400 bg-primary-50 dark:bg-primary-900/20'
                  : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 hover:bg-gray-50 dark:hover:bg-slate-800'
                }
              `}
            >
              {tab.icon && <tab.icon className="h-4 w-4" />}
              <span>{tab.label}</span>
              {tab.badge !== undefined && (
                <span className={`
                  px-2 py-0.5 text-xs font-medium rounded-full
                  ${shouldBeActive
                    ? 'bg-primary-100 dark:bg-primary-800/50 text-primary-700 dark:text-primary-300'
                    : 'bg-gray-100 dark:bg-slate-700 text-gray-600 dark:text-gray-400'
                  }
                `}>
                  {tab.badge}
                </span>
              )}
              {/* Indicator line */}
              {shouldBeActive && (
                <span className="absolute bottom-0 left-0 right-0 h-0.5 bg-primary-600 dark:bg-primary-400 rounded-full" />
              )}
            </NavLink>
          )
        })}
      </nav>
    </div>
  )
}
